import { getActivityScore, postError } from "./api_controller";
import { doLog } from "@/lib/globals";

const POLLING_INTERVAL_MS = 1000;
const MAX_POLLING_ATTEMPTS = 40;

export async function pollForScore() {
  try {
    if (doLog()) console.info("Starting score polling");
    let count = 0;

    while (true) {
      count++;
      if (doLog()) console.info(`Polling for score ${count}...`);

      // Fail if we've reached the max polling attempts
      if (count > MAX_POLLING_ATTEMPTS) {
        if (doLog()) console.warn("Max polling attempts reached, breaking");
        break;
      }

      // Call the API to get the score
      const out = await getActivityScore();
      if (doLog()) console.info("getActivityScore() returned:", out);

      // Fail if the response is null or -1
      if (!out) {
        if (doLog()) console.warn("Response is null, breaking");
        break;
      } else if (out == -1) {
        if (doLog()) console.warn("Response is -1, breaking");
        break;
      }

      // Print info if available
      const info = out.info;
      if (doLog() && info) console.info("Info:", info);

      // Get chat message if available
      const chatMessage = out.chat_message;
      if (chatMessage) {
        if (doLog()) console.info("Chat message:", chatMessage);
        return chatMessage;
      }

      // Fail if continue polling is false
      const continuePolling = out.continue_polling;
      if (!continuePolling) {
        if (doLog()) console.info("Continue polling is false, breaking");
        break;
      }

      // Wait for the polling interval
      await new Promise((resolve) => setTimeout(resolve, POLLING_INTERVAL_MS));
    }

    return buildScoringFailedMessage();
  } catch (error) {
    const errorMessage = `pollForScore() ${error.message}`;
    console.error(errorMessage, error);
    postError(errorMessage, error);
    return buildScoringFailedMessage();
  }
}

function buildScoringFailedMessage() {
  const userMessage =
    "Scoring failed. Please check the activity list in the Taalia app to see if the activity and score are available there.";
  return {
    isError: true,
    utterance: userMessage,
    senderId: "api",
    ixid: {
      messageId: "error",
      scriptId: "common",
    },
  };
}
